import{jsx}from"react/jsx-runtime";function RouterLink({children,...props}){return jsx("a",{...props,children})}export{RouterLink};
